import * as React from 'react'
import { cn } from '@/lib/utils'
import { useTheme } from '@/hooks/use-theme'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const { theme } = useTheme()

    return (
      <input
        type={type}
        className={cn(
          `flex h-10 w-full rounded-md border 
          ${theme === 'dark' ? '!border-[#2e2e2e] bg-[#262626]' : ' bg-background'}
          px-3 py-2 text-sm ring-offset-background file:text-sm file:font-medium 
          placeholder:text-muted-foreground focus-visible:outline-none 
          focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 
          disabled:cursor-not-allowed disabled:opacity-50`,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
